<template>
  <LcCard>
    <ScratchcardQuantityStack />

    <div class="flex flex-col items-center">
      <ScratchcardQuantityPicker />
      <ScratchcardQuantityRemaining />
    </div>
  </LcCard>
</template>
